<template>
    <div id="app">
        <header>
            <h1>Players Store</h1>
            <cart-count v-bind:nbItmesInCart="cartPlayers.length"></cart-count>
        </header>
        <section>
            <article>
                <h2>Catalogues :</h2>
                <Catalog v-on:cart-add-player="CartAddPlayer" :players="players"></Catalog>
            </article>
            <article>
                <h2>Panier :</h2>
                <Cart v-on:cart-remove-player="CartRemovePlayer" :cartPlayers="cartPlayers"></Cart>
            </article>
            <article>
                <h2>Gestion :</h2>
                <Inventory v-on:players-add-player="PlayersAddPlayer"></Inventory>
            </article>
        </section>
    </div>
</template>

<script>
    // Chargement des composent vue
    import Catalog from './components/Catalog';
    import Cart from './components/Cart';
    import Inventory from './components/Inventory';
    import CartCount from './components/CartCount';

    // Chargement du script pour la bdd
    import {playersRef} from './data/bdd';


    export default {
        name: 'app',
        components: {
            Catalog,
            Cart,
            Inventory,
            CartCount,
        },
        watch: {
            //Sauvegarde du panier
            cartPlayers(newCartPlayers) {
                localStorage.cartPlayers = JSON.stringify(newCartPlayers);
            }

        },
        methods: {
            //Ajoute un player à la bdd
            PlayersAddPlayer: function (aPlayer) {
                const newPlayerRef = playersRef.push();
                newPlayerRef.set(aPlayer);
            },

            //Suprime un player du panier
            CartRemovePlayer: function (aPlayer) {
                let tmp = [];
                this.cartPlayers.forEach(value => {
                    if (value['.key'] !== aPlayer['.key']) {
                        tmp.push(value);
                    }
                });
                this.cartPlayers=tmp;
            },

            //Ajoute un player au panier
            CartAddPlayer: function (aPlayer) {
                var inCart = false;
                this.cartPlayers.forEach(value => {
                    if (value['.key'] === aPlayer['.key']) {
                        inCart = true;
                    }
                });
                if (!inCart) {
                    this.cartPlayers.push(aPlayer);
                }
            },
        },
        data() {
            return {
                cartPlayers: [],
            }
        },
        firebase() {
            return {
                players: {
                    // On charge les joueur depuis la bdd
                    source: playersRef,
                }
            }
        },
        mounted() {
            // Chargement des joueurs du panier
            if (localStorage.cartPlayers) {
                this.cartPlayers = JSON.parse(localStorage.cartPlayers);
            }
        }
    }

</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /*margin-top: 60px;*/
    }

    section {
        display: flex;
        flex-wrap: wrap;
    }

    section > article {
        flex: 1;
        margin-right: 10px;
        margin-left: 10px;
    }

    input[type="button"]{
        border-radius: 20px;
    }
    article{
        min-width: 400px;
    }
</style>
